import React, { Component } from 'react';
import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
// Be sure to include styles at some point, probably during your bootstraping
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import '../SideDraw/folders.css';
import FetchData from '../../Utils/FetchData';
import { connect } from 'react-redux'
import setDirectoryIdAction from '../../../actions/setDirectoryIdAction'
import setFolderIdAction from '../../../actions/setFolderIdAction'
import setFolderNameAction from '../../../actions/setFolderNameAction'
import setDirectoryNameAction from '../../../actions/setDirectoryNameAction'
import setFolderViewAction from '../../../actions/setFolderViewAction'
import setCurrentObjectId from '../../../actions/setCurrentObjectId';
import setActionDashboardlist from '../../../actions/setActionDashboardlist';
import setActionFolderNotifications from '../../../actions/setActionFolderNotifications';
import setActionFolderExpColaps from '../../../actions/setActionFolderExpColaps';

import SvgFolderIcon from '../../../iconComponents/folderIcon';




//Comment from tmourselas 29-01-19 (TM 29-01-19 )
var ordinalPositionArray = [];
class Folders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            merge: [],
            Folders: [],
            expanded: true,
            directoryExpanded: true,
            active: false,
        };

        this.fetchFolders()
    }

    onToggle = (expanded) => {



        if (expanded === false) {
            this.props.actionDashboardlistset(undefined)
            //document.body.style.backgroundImage = "url('img_tree.png')";
            document.getElementById("main").style.marginLeft = "-134px";
            document.getElementById("Toggle").style.backgroundColor = "#2999E3";
            document.getElementById("Toggle").style.transform = "scaleX(-1)";
            document.getElementById("Toggle").style.marginRight = "10px";



        }
        if (expanded === true) {
            this.props.actionDashboardlistset(undefined)
            document.getElementById("main").style.marginLeft = "0px";
            document.getElementById("Toggle").style.backgroundColor = "#6f7e95";
            document.getElementById("Toggle").style.transform = "scaleX(1)";
            document.getElementById("Toggle").style.marginRight = "-35px";


        }
        this.props.actionFolderExpandCollapse(expanded)
        this.setState({ expanded: expanded });
    };
    onSelect = (select) => {


        this.setState({ active: true })


    };
    onClick = (e) => {


    }
    componentDidMount() {

        if (this.props.folderIdState !== undefined) {
            this.setState({ active: true })

        }

    }
    componentDidUpdate(prevProps, prevState) {

        if (prevProps.multirootContext !== this.props.multirootContext) {

            this.fetchFolders()

        }
        if (prevProps.taskIdState != this.props.taskIdState) {

            this.fetchFolders()
        }
        if (this.state.clipoard == true) {

            this.setState({ clipoard: false })
        }
        if (prevProps.directoryNameState != this.props.directoryNameState) {


            this.onSelect(this.props.folderNameState)
        }

    }
    fetchFolders() {
     
        if (this.props.roledataId != null && this.props.taskIdState) {
           // alert('1')
            FetchData('/api/RTFCW/DirectoriesAndFoldersInfoA/' + this.props.roledataId + '/' + this.props.taskIdState)
                .then((data) => {
                  //  alert('2')
                    let Directories = data.data.Directories
                    let FoldersItems = data.data.Folders

                    if (this.props.notificationsFolders != undefined) {
                        for (var value of this.props.notificationsFolders) {

                            data.data.Folders.map((i) => {

                                if (i.id === value.folderId) {

                                    i.count = value.folderCount
                                }
                            })
                        }
                    }

                    const merge1 = FoldersItems.sort((c, d) => {
                        if (c.displayOrder == d.displayOrder) {
                            if (c.ordinalPosition == d.ordinalPosition) {
                                if (c.isCommon == d.isCommon) {
                                    return 0
                                }
                                else {
                                    if (c.isCommon) {
                                        return -1
                                    }
                                    else {
                                        return 1
                                    }
                                }
                            }
                            else {
                                return c.ordinalPosition - d.ordinalPosition
                            }
                        }
                        else {
                            return c.displayOrder - d.displayOrder
                        }
                    })

                    let mergeById = (a1, a2) =>
                        a1.map(itm => ({
                            ...a2.find((item) => (item.directoryId === itm.id) && item),
                            ...itm
                        }));


                    const mergeDirectoryFolderItems = (mergeById(Directories, merge1).filter(item => item.id === item.directoryId))

                    const merge = mergeDirectoryFolderItems.sort((a, b) => {
                        return (a.ordinalPosition - b.ordinalPosition);
                    })

                    var firstObj = []
                    FoldersItems.map((i) => {

                        if (merge[0].id === i.directoryId) {

                            firstObj.push({ name: i.displayName, id: i.id, displayOrder: i.displayOrder });
                        }

                    })


                    if (this.props.TabState !== true) {
                        //alert('edo?')
                        this.props.directoryIdSet(merge[0].id)
                        this.props.directoryNameSet(merge[0].name)
                        this.props.folderNameSet(firstObj[0].name)
                        this.props.folderIdSet(firstObj[0].id)
                        this.props.folderViewKeySet(merge[0].viewKey)
                    }


                    this.setState({
                        merge: merge,
                        Folders: FoldersItems,
                    })
                }).catch(function (error) {
                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                });

        }
    }


    OpenFolder = (id) => {
       
        this.props.actionDashboardlistset(undefined)
        this.props.currObjectSet(undefined)
        var splitId = id.split(',')
        this.props.folderNameSet(splitId[0])
        this.props.folderIdSet(splitId[1])
        this.props.folderViewKeySet(splitId[4])
        this.props.directoryIdSet(splitId[2])
        this.props.directoryNameSet(splitId[3])

        this.props.actionFolderNotificationset(splitId[5])
    }

    changedirectory = (id) => {

        var splitId = id.split(',')
        this.props.directoryNameSet(splitId[0])
        this.props.directoryIdSet(splitId[1])
    }



    render() {


        var folderstyles;

        if (this.props.themeState === false || this.props.themeState === undefined) {

            folderstyles = window.defaultTheme;
        } else {

            folderstyles = window.darkTheme;
        }


        return (

            <SideNav id="scroll" onToggle={this.onToggle} expanded={this.state.expanded}

                onSelect={this.onSelect}
            >
                <SideNav.Toggle id="Toggle" />

                <SideNav.Nav defaultSelected={this.props.directoryNameState} >

                    {
                        this.state.merge.map((value) => {
                            var ico = <SvgFolderIcon />
                            if (value.name === this.props.directoryNameState) {

                                return (<NavItem expanded={this.state.directoryExpanded} >
                                    <NavText>
                                        {value.name}
                                    </NavText>
                                    {
                                        this.state.Folders.map((folderitem) => {
                                            if (folderitem.directoryId === value.id) {
                                                if (folderitem.displayName === this.props.folderNameState) {
                                                    if (folderitem.count > 0) {

                                                        return (<NavItem active={this.state.active} >

                                                            <NavText onClick={this.OpenFolder.bind(this, folderitem.displayName + "," + folderitem.id + "," + value.id + "," + value.name + "," + folderitem.viewKey + "," + folderitem.count)}>
                                                                {folderitem.displayName}
                                                                <b className="badgeFolderblue badge-notify">{
                                                                    folderitem.count}</b>
                                                            </NavText>
                                                        </NavItem>)
                                                    } else {

                                                        return (<NavItem active={this.state.active} >

                                                            <NavText onClick={this.OpenFolder.bind(this, folderitem.displayName + "," + folderitem.id + "," + value.id + "," + value.name + "," + folderitem.viewKey + "," + folderitem.count)}>
                                                                {folderitem.displayName}

                                                            </NavText>
                                                        </NavItem>)
                                                    }

                                                } else {
                                                    if (folderitem.count > 0) {

                                                        return (<NavItem >

                                                            <NavText onClick={this.OpenFolder.bind(this, folderitem.displayName + "," + folderitem.id + "," + value.id + "," + value.name + "," + folderitem.viewKey + "," + folderitem.count)}>
                                                                {folderitem.displayName}   <b className="badgeFolderblue badge-notify">{
                                                                    folderitem.count}</b>
                                                            </NavText>
                                                        </NavItem>)
                                                    }
                                                    else {

                                                        return (<NavItem >

                                                            <NavText onClick={this.OpenFolder.bind(this, folderitem.displayName + "," + folderitem.id + "," + value.id + "," + value.name + "," + folderitem.viewKey + "," + folderitem.count)}>
                                                                {folderitem.displayName}
                                                            </NavText>
                                                        </NavItem>)
                                                    }

                                                }
                                            }
                                        })
                                    }

                                </NavItem>)
                            } else {

                                return (<NavItem onClick={this.onClick} eventKey={value.id} >

                                    <NavText>

                                        {value.name}
                                    </NavText>
                                    {
                                        this.state.Folders.map((folderitem) => {
                                            if (folderitem.directoryId === value.id) {

                                                if (folderitem.count > 0) {
                                                    return (<NavItem >
                                                        <NavText onClick={this.OpenFolder.bind(this, folderitem.displayName + "," + folderitem.id + "," + value.id + "," + value.name + "," + folderitem.viewKey + "," + folderitem.count)}>

                                                            {folderitem.displayName}<b className="badgeFolderblue badge-notify">{folderitem.count}</b>
                                                        </NavText>
                                                    </NavItem>)
                                                } else {
                                                    return (<NavItem >
                                                        <NavText onClick={this.OpenFolder.bind(this, folderitem.displayName + "," + folderitem.id + "," + value.id + "," + value.name + "," + folderitem.viewKey + "," + folderitem.count)}>

                                                            {folderitem.displayName}
                                                        </NavText>
                                                    </NavItem>)
                                                }

                                            }
                                        })
                                    }
                                </NavItem>)
                            }
                        })
                    }
                </SideNav.Nav>
            </SideNav>
        );
    }
}
const mapStateToProps = state => {
    return {
        roledataId: state.roleDataId,
        taskNameState: state.taskDataName,
        taskIdState: state.taskDataId,
        folderIdState: state.folderDataId,
        folderNameState: state.folderDataName,
        directoryNameState: state.directoryDataName,
        directoryIdState: state.directoryDataId,
        themeState: state.currentThemeName,
        notificationsFolders: state.currentNotificationsFolders,
        multirootContext: state.currentActionmultiroot,
        TabState: state.currTabsState

    }
};
const mapDispatchToProps = dispatch => {
    return {
        folderNameSet: payload => dispatch(setFolderNameAction(payload)),
        folderIdSet: payload => dispatch(setFolderIdAction(payload)),
        folderViewKeySet: payload => dispatch(setFolderViewAction(payload)),
        directoryIdSet: payload => dispatch(setDirectoryIdAction(payload)),
        directoryNameSet: payload => dispatch(setDirectoryNameAction(payload)),
        currObjectSet: payload => dispatch(setCurrentObjectId(payload)),
        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        actionFolderNotificationset: payload => dispatch(setActionFolderNotifications(payload)),
        actionFolderExpandCollapse: payload => dispatch(setActionFolderExpColaps(payload)),


    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Folders);





// WEBPACK FOOTER //
// ./src/components/TaskView/SideDraw/Folders.js